export const modulo = (input: string, module: number): number => {
    return Array.from(input)
        .map((c) => parseInt(c, 10))
        .reduce((remainder, value) => (remainder * 10 + value) % module, 0);
};

type Coordinates = {
    lat: number;
    lng: number;
};

const EARTH_RADIUS_IN_KMS = 6371;
const DEG_TO_RADS_FACTOR = Math.PI / 180;

export const degreesToRadians = (deg: number) => deg * DEG_TO_RADS_FACTOR;

/**
 * Harversine formula
 * Used to determine the distance between two points on a sphere given their coordinates
 *
 * @param point1 - Coordinates of the first point
 * @param point2 - Coordinates of the second point
 * @returns The distance between these points in km
 */
export const harversine = (
    { lat: lat1deg, lng: lng1deg }: Coordinates,
    { lat: lat2deg, lng: lng2deg }: Coordinates
) => {
    const lat1 = degreesToRadians(lat1deg);
    const lng1 = degreesToRadians(lng1deg);
    const lat2 = degreesToRadians(lat2deg);
    const lng2 = degreesToRadians(lng2deg);

    const a =
        0.5 -
        Math.cos(lat2 - lat1) / 2 +
        (Math.cos(lat1) * Math.cos(lat2) * (1 - Math.cos(lng2 - lng1))) / 2;

    return 2 * EARTH_RADIUS_IN_KMS * Math.asin(Math.sqrt(a));
};
